// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Mob() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/MOB/MOB_1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/MOB/MOB_2.jpg'
        },
        {
            id: 3,
            imgSrc: '/images/MOB/MOB_3.jpg'
        },
        {
            id: 4,
            imgSrc: '/images/MOB/MOB_4.jpg'
        },
        {
            id: 5,
            imgSrc: '/images/MOB/MOB_5.jpg'
        },
        {
            id: 6,
            imgSrc: '/images/MOB/MOB_6.jpg'
        },
        {
            id: 7,
            imgSrc: '/images/MOB/MOB_7.jpg'
        },
        
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="MOB" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="MOB" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Mob;
